// extracted by mini-css-extract-plugin
export default {"input":"textarea_input__JBAsd","wrapper":"textarea_wrapper__Ipw0T","inscription":"textarea_inscription__pWh5t"};